import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { OutOfJurisdictionRegistrationModel } from '@max/commercialpermitting/models/out-of-jurisdiction-registration.model';
import { CommercialOutOfJurisdictionRegistrationService } from '@max/commercialpermitting/services/commercial-out-of-Jurisdiction-registration.service';
import { BaseComponent } from '@max/shared/base-components/base.component';

export class OutOfJurisdictionRegistrationHistoryModalData {
    constructor(public vehicleId: number) {}
}

@Component({
    selector: 'out-of-jurisdiction-registration-history-modal',
    templateUrl: './out-of-jurisdiction-registration-history-modal.html'
})
export class OutOfJurisdictionRegistrationHistoryModalComponent extends BaseComponent {
    public dataLoaded = false;
    public outOfJurisdictionRegistrations: OutOfJurisdictionRegistrationModel[] = [];

    constructor(
        public dialogRef: MatDialogRef<OutOfJurisdictionRegistrationHistoryModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: OutOfJurisdictionRegistrationHistoryModalData,
        private outOfJurisdictionRegistrationService: CommercialOutOfJurisdictionRegistrationService
    ){
        super();
    }

    public ngOnInit() {
        this.outOfJurisdictionRegistrationService.getOutOfJurisdictionRegistrations(this.data.vehicleId).subscribe(r => {
            this.outOfJurisdictionRegistrations = r;
            this.dataLoaded = true;
        });
    }

    public cancel() {
        this.dialogRef.close(false);
    }

}
